import { formatCurrency } from "helpers";
import { CalculationDetailItem } from "services/api/calculations/types";
import InfoCard from "../InfoCard/InfoCard";
import { CalculationBreakdownCardProps } from "./types";

interface ItemGroup {
  key: string;
  title: string;
  order: number;
  items: CalculationDetailItem[];
}

// Stavke se grupiraju po nadređenom tipu (CalculationItemTypeParent); ako ga nema,
// koristi se vlastiti tip, a kao zadnji fallback "Ostalo".
const groupItems = (items: CalculationDetailItem[]): ItemGroup[] => {
  const groups = new Map<string, ItemGroup>();

  items.forEach((item) => {
    const parent = item.type?.parent;
    const key = parent?.id ?? item.type?.id ?? "other";
    const title = parent?.name ?? item.type?.name ?? "Ostalo";
    const order = parent?.displayOrder ?? item.type?.displayOrder ?? 999;

    if (!groups.has(key)) {
      groups.set(key, { key, title, order, items: [] });
    }
    groups.get(key)!.items.push(item);
  });

  return Array.from(groups.values()).sort((a, b) => a.order - b.order);
};

const CalculationBreakdownCard: React.FC<CalculationBreakdownCardProps> = (
  props
) => {
  const { calculation } = props;

  const groups = groupItems(calculation.items);

  return (
    <div className="px-4 pt-4 pb-4">
      {calculation.name && (
        <div className="text-md font-bold text-slate-600 mb-3 truncate">
          {calculation.name}
        </div>
      )}

      {/* Period / km / ukupno */}
      <div className="grid grid-cols-3 gap-3 mb-4">
        <InfoCard
          label="Trajanje"
          value={
            calculation.rentMonths != null ? `${calculation.rentMonths} mj` : ""
          }
        />
        <InfoCard
          label="Kilometraža"
          value={
            calculation.rentKm != null
              ? `${calculation.rentKm.toLocaleString("hr-HR")} km`
              : ""
          }
        />
        <div className="border border-green-200 bg-green-50 p-3 rounded-sm min-h-[70px]">
          <div className="text-sm text-green-600 font-semibold">Ukupno</div>
          <div className="text-md font-bold text-green-600 truncate">
            {calculation.totalPrice != null
              ? formatCurrency.format(calculation.totalPrice)
              : "-"}
          </div>
        </div>
      </div>

      {/* Razrada */}
      {groups.length > 0 && (
        <>
          <div className="text-sm font-bold text-slate-600 mb-3">
            Razrada cijene
          </div>
          <div className="">
            {groups.map((group) => (
              <div
                key={group.key}
                className="border border-slate-200 overflow-hidden mt-[-1px]"
              >
                <div className="bg-slate-50 px-4 py-2 text-sm font-semibold text-slate-700">
                  {group.title}
                </div>
                <div className="divide-y divide-slate-100">
                  {group.items.map((item, idx) => (
                    <div
                      key={item.id ?? idx}
                      className="flex justify-between px-4 py-2 text-sm"
                    >
                      <span className="text-slate-600">
                        {item.type?.name ?? item.description ?? "-"}
                      </span>
                      <span className="font-medium text-slate-800">
                        {item.price != null
                          ? formatCurrency.format(item.price)
                          : "-"}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* <div className="flex justify-between items-center border-t-2 border-slate-200 mt-4 pt-3">
            <span className="text-sm font-bold text-slate-600 uppercase">
              Ukupno
            </span>
            <span className="text-xl font-bold text-green-600">
              {calculation.totalPrice != null
                ? formatCurrency.format(calculation.totalPrice)
                : "-"}
            </span>
          </div> */}
        </>
      )}
    </div>
  );
};

export default CalculationBreakdownCard;
